














































































































































import {Component, Vue} from "vue-property-decorator";
import Customer from "@/api/Customer";
import CustomerService from "@/service/CustomerService";
import CustomerNameEditFormView from "@/components/Dashboard/Customer/CustomerNameEditFormView.vue";
import CustomerEmailEditFormView from "@/components/Dashboard/Customer/CustomerEmailEditFormView.vue";
import CustomerPasswordEditFormView from "@/components/Dashboard/Customer/CustomerPasswordEditFormView.vue";
import CustomerMobileEditFormView from "@/components/Dashboard/Customer/CustomerMobileEditFormView.vue";
import CustomerNewsletterEditFormView from "@/components/Dashboard/Customer/CustomerNewsletterEditFormView.vue";
import CustomerImageEditFormView from "@/components/Dashboard/Customer/CustomerImageEditFormView.vue";
import Loading from "@/components/Shared/Loading.vue";

@Component({
  components: {
    Loading,
    CustomerNewsletterEditFormView,
    CustomerMobileEditFormView,
    CustomerPasswordEditFormView,
    CustomerNameEditFormView,
    CustomerEmailEditFormView,
    CustomerImageEditFormView
  }
})
export default class CustomerInfoView extends Vue {
  private customer: Customer | null = null;
  private formView: string | null = null;
  private imageVisible = false;

  mounted() {
    this.getCurrentCustomer();
  }

  async getCurrentCustomer() {
    this.imageVisible = false;
    this.$store.dispatch('loading/showLoadingModal');
    this.customer = await CustomerService.getCurrentCustomer();
    this.$store.dispatch('loading/hideLoadingModal');
    this.imageVisible = true;
  }

  showForm(formName: string) {
    this.formView = formName;
  }

  closeForm(saved = false) {
    this.formView = null;
    if (saved) {
      this.getCurrentCustomer();
    }
  }
}
